import { DateTime } from "luxon";
import { useEffect, useState } from "react";

import { useFindRelevantFoodActivitiesQuery } from "src/api/food/findRelevantFoodActivities.generated";
import { TMEAL } from "src/views/status/constants/types";

export const useFoodActivitiesPolling = (pollInterval = 10000) => {
  const [meals, setMeals] = useState<TMEAL[]>([]);

  const { data, loading, error, refetch } = useFindRelevantFoodActivitiesQuery({
    pollInterval,
    notifyOnNetworkStatusChange: false,
  });

  useEffect(() => {
    if (data?.findRelevantFoodActivities) {
      const transformedMeals: TMEAL[] = data.findRelevantFoodActivities.map(
        (activity) => {
          // Convert GMT times to EST using Luxon
          const startTime = DateTime.fromISO(activity.start_time, {
            zone: "utc",
          }).setZone("America/New_York");
          const endTime = DateTime.fromISO(activity.end_time, {
            zone: "utc",
          }).setZone("America/New_York");
          const lastUpdated = activity.food_line?.updated_at
            ? DateTime.fromISO(activity.food_line.updated_at, {
                zone: "utc",
              }).setZone("America/New_York")
            : DateTime.fromISO(activity.updated_at, {
                zone: "utc",
              }).setZone("America/New_York");

          // Set waitTime equal to serviceSpeed (ignore approx_length)
          const waitTime = activity.food_line?.service_speed || 0;
          const status = activity.food_line?.status || "Fast";

          return {
            mealTitle: activity.name,
            startTime,
            endTime,
            location: activity.location || "",
            serviceSpeed: status,
            waitTime,
            status,
            lastUpdated,
            eventActivityId: activity.id,
            foodLineData: {
              approx_length: activity.food_line?.approx_length || 0,
              service_speed: activity.food_line?.service_speed || 0,
              status: activity.food_line?.status || "Fast",
            },
          };
        }
      );

      // Sort meals by start time
      const sortedMeals = transformedMeals.sort(
        (a, b) => a.startTime.toMillis() - b.startTime.toMillis()
      );

      setMeals(sortedMeals);
    }
  }, [data]);

  // Only show loading state on initial load, not during refetches
  const isLoading = loading && !meals.length;
  const isRefetching = loading && meals.length > 0;

  return {
    meals,
    loading: isLoading,
    isRefetching,
    error,
    refetch,
  };
};
